import * as actionTypes from 'redux/actions'

const initialState = {
  campaignSearch: '',
  packageId: 'all',
  userType: 'both',
  managePackageId: 'all',
  manageSearch: '',
  brandsFilter: 'all',
  manageEndDate: new Date('2022-07-09'),
  manageStartDate: new Date('2020-06-09')
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CAMPAIGN_SEARCH: {
      return {
        ...state,
        campaignSearch: action.payload
      }
    }
    case actionTypes.SET_PACKAGE_FILTER: {
      return {
        ...state,
        packageId: action.payload
      }
    }
    case actionTypes.SET_MANAGE_PACKAGE_FILTER: {
      return {
        ...state,
        managePackageId: action.payload
      }
    }
    case actionTypes.SET_MANAGE_BRANDS_SEARCH: {
      return {
        ...state,
        brandsFilter: action.payload
      }
    }
    case actionTypes.SET_MANAGE_SEARCH: {
      return {
        ...state,
        manageSearch: action.payload
      }
    }
    case actionTypes.SET_COMPANY_SEARCH: {
      return {
        ...state,
        companySearch: action.payload
      }
    }
    case actionTypes.SET_MANAGE_START_DATE: {
      return {
        ...state,
        manageStartDate: action.payload
      }
    }
    case actionTypes.SET_MANAGE_END_DATE: {
      return {
        ...state,
        manageEndDate: action.payload
      }
    }
    case actionTypes.SET_USER_TYPE_FILTER: {
      return {
        ...state,
        userType: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default dashboardReducer
